import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AssetService } from '../../services/asset-service';
import { AssetTransferService } from '../../services/asset-transfer.service';
import { TicketService } from '../../services/ticket-service';
import { BaseWidget } from 'src/app/tools/abstract-classes/base-widget';
import { AssetTransfer } from '../../models/entities/asset-transfer';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { Asset } from 'src/app/assabil-kernel/models/entities/master-data/asset';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { AssetPipe } from '../../pipes/asset-pipe';
import { AssetTransferPipe } from '../../pipes/asset-transfer-pipe';
import { AssetAssignment } from '../../models/entities/asset-assignment';
import { AssetAssignmentService } from '../../services/asset-assignment.service';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { TicketPipe } from '../../pipes/ticket-pipe';
import { AssetProduct } from 'src/app/assabil-kernel/models/entities/control-tables/asset-product-entity';


@Component({
    selector: 'asset-widget',
    templateUrl: './asset-widget.component.html',
    styleUrls: ['./asset-widget.component.scss']
})

export class AssetWidgetComponent extends BaseWidget {

  assetTransferFields   : any;
  assetAssignmentFields : any;
  spareFields           : any;
  ticketFields          : any;
  assetTransfers        : AssetTransfer[];
  assetAssignments      : AssetAssignment[];

  asset                 : Asset = new Asset();
  servicesPath          : string = 'services/controls/'

  assetTransferPipe     : AssetTransferPipe = new AssetTransferPipe();

  spares :  AssetProduct[];

  constructor(
      protected baseService           : BaseService,
      protected assetService          : AssetService,
      protected ticketService         : TicketService,
      protected assetTransferService  : AssetTransferService,
      protected assetAssignmentService: AssetAssignmentService,
      protected controlTablesService  : ControlTablesService,
      protected toastr                : ToastrService,
      protected leanUtilsService      : LeanUtilsService) {
        super(toastr, leanUtilsService);
  }


  ngOnInit(){
    super.ngOnInit();
    this.setColumns();
  }
   //------------------------------------------------------
  setEntity(asset: Asset) {
    this.asset = { ...asset };
  }

  getEntity(){
      return this.asset;
  }
  //------------------------------------------------------



  setColumns(){

  
  this.spareFields = [
    { prop: 'assetProductCode',       name: 'Code',              type: 'text'  },
    { prop: 'name',                   name: 'Nom',               type: 'text'  },
    { prop: 'quantity',               name: 'Qté',               type: 'number'},
    { prop: 'amount',                 name: 'Montant',           type: 'number', style: {'font-weight': 'bold', 'font-style': 'italic', 'color' : 'darkred'}  },
  ]

  this.assetTransferFields = [
    { prop: 'theDate',                  name: 'Date',      type: 'date',  style: {'font-weight': 'bold', 'font-style': 'italic'}  },
    { prop: 'fromBranch.name',          name: 'De',},
    { prop: 'toBranch.name',            name: 'Vers',},
    { prop: 'progressLevel',            name: 'Statut', pipe : this.assetTransferPipe},
    { prop: 'assetTransferCode',        name: 'N° Transfert' },
  ]

  this.assetAssignmentFields = [
    { prop: 'installConfirmationDate', name: 'Installation',      type: 'date',  style: {'font-weight': 'bold', 'font-style': 'italic'}  },
    { prop: 'returnConfirmationDate',  name: 'Retrait',           type: 'date',  style: {'font-weight': 'bold', 'font-style': 'italic'}  },
    { prop: 'partner.name',            name: 'Client',},
    { prop: 'assetAssignmentCode',     name: 'N° Affectation' },
  ]

}



//----------------------------------------------------------------------
  saveRow() : Promise<Asset>{
    return  this.assetService.assetSave(this.asset);
  }
//----------------------------------------------------------------------



//----------------------------------------------------------------------
assetTransfersExpanded(b : boolean) {
      if (b && ( (! this.assetTransfers) || (this.assetTransfers.length == 0))){
        this.assetTransferService.assetAssetTransfersGet(this.asset.assetCode).then(result => {
          this.assetTransfers = result;              
        }) 
      }
  } 
//----------------------------------------------------------------------

 //----------------------------------------------------------------------
 assetAssignmentsExpanded(b : boolean) {
  if (b && ( (! this.assetAssignments) || (this.assetAssignments.length == 0))){

    this.assetAssignmentService.assetAssetAssignmentsGet(this.asset.assetCode).then(result => {
      this.assetAssignments = result;              
    }) 
  }
} 
//----------------------------------------------------------------------


//----------------------------------------------------------------------
assetTicketsExpanded(b : boolean) {
    if (b && ( (! this.asset.tickets) || (this.asset.tickets.length == 0))){
       this.processAssetTickets();             
    }
}
//----------------------------------------------------------------------


ticketPipe : TicketPipe = new TicketPipe();
//----------------------------------------------------------------------
processAssetTickets(){

  if (this.ticketFields) {
    this.loadAssetTickets();
    this.loadAssetSpares();
    return;
  }

  this.baseService.fieldsGet('ticket').then(result => {
      this.ticketFields  = result.listFields;
      this.readOnly   = true;
      for(let field of this.ticketFields){
        if (field.prop == 'progressLevel') {
            field.pipe = this.ticketPipe;
        }
      }
       this.loadAssetTickets();
       this.loadAssetSpares();
  });
}


  /*
    this.ticketFields = [
      { prop: 'creationDate',             name: 'Date',               type: 'date',  style: {'font-weight': 'bold', 'font-style': 'italic'}  , readOnly :true },

      { prop : 'ticketType',              name : 'Type',              required : true,   key : 'ticketTypeCode',     lov :  {     key     : "ticketTypeCode", 
                                                                                                                                  value   : "name", 
                                                                                                                                  data    : this.ticketTypes
                                                                                                                              },
                                                                                                                      insertOnly :true                           },
      { prop: 'description',              name: 'Description',        required : true},
      { prop : 'priority',                name : 'Priorité',          required : true,                               lov :  {    key     : "rank", 
                                                                                                                                value   : "name", 
                                                                                                                                data    : this.prioritiesList
                                                                                                                            }                           },
    ]
    */


//----------------------------------------------------------------------
loadAssetSpares() {
  this.ticketService.assetSparesGet(this.asset.assetCode).then(spares => {
    this.spares = spares;  
    let sparesTotalAmount = 0;
    if (this.spares){
      for (let spare of this.spares) sparesTotalAmount += spare.amount;
      let tmp : AssetProduct = new AssetProduct();
      tmp.name = 'Total  ';
      tmp.amount = sparesTotalAmount;
      this.spares.push(tmp);
    }          
  })
}
//----------------------------------------------------------------------
loadAssetTickets() {
  let 
  id                      : number,
  ticketCategoryId        : number,
  ticketTypeId            : number,
  branchCode              : string,
  partnerCode             : string,
  itineraryCode           : string,
  assetBarCode            : string = this.asset.barCode,
  assetProductCategoryCode: string,
  priority                : number,
  newlyCreated_PL 		    : boolean = true,
  toBeRualified_PL 		    : boolean = true, 
  qualified_PL            : boolean = true,
  scheduled_PL            : boolean = true,
  processed_PL            : boolean = true,
  closed_PL               : boolean = true,
  ticketBatchId           : number;

    this.ticketService.ticketsGet(                        
      id                    ,
      ticketCategoryId      ,
      ticketTypeId          ,
  
      branchCode              ,
      partnerCode             ,
      itineraryCode           ,
  
      assetBarCode            ,
      assetProductCategoryCode,
  
      priority              ,
  
      newlyCreated_PL 	    ,
      toBeRualified_PL      ,
      qualified_PL          ,
      scheduled_PL          ,
      processed_PL          ,
      closed_PL,
      ticketBatchId         ).then(result => {
      this.asset.tickets = result;   
      this.loadAssetSpares();           
    })
  }
//----------------------------------------------------------------------

//----------------------------------------------------------------------
closeAsset(){;
    this.assetService.assetClose(this.asset.assetCode).then(asset => {
      this.asset = asset;   
      this.showSuccessFulOperation();           
    }) 
}
//----------------------------------------------------------------------



//----------------------------------------------------------------------
assetPipe : AssetPipe = new AssetPipe();
getBadges() : string {
  let res = this.assetPipe.transform(this.asset, 'assetStatusCode') ;
  let tk = this.assetPipe.transform(this.asset, 'ticketsNumber');
  let tk2 = this.assetPipe.transform(this.asset, 'closed');
  if (tk) res += tk;
  if (tk2) res = tk2 + res;
  res = "<div class='label-flex'>" + res + "</div>";
  return res;
}
//----------------------------------------------------------------------

}
